/**
 * @author Fernando Ruano
 * @file index.js
 * @description Button Outlined Component
 */

// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

// Styles
import styles from './styles.module.css';

/**
 * Button Outlined Component
 * @param { Object } props - React PropTypes
 * @property { Function } onActionClick - oClick Button function.
 * @property { String } textButton - Text button.
 * @property { String } classStyles - Button Style Class.
 */
const ButtonOutlined = ({
  onActionClick,
  textButton,
  classStyles,
  iconComponent,
  htmlType,
  type
}) => {
  const { t: translate } = useTranslation();
  return (
    <Button
      htmlType={htmlType}
      onClick={onActionClick}
      className={[styles.outlinedButton, styles[type], classStyles]}
      type="default"
      icon={iconComponent}>
      {translate(textButton)}
    </Button>
  );
};

/**
 * @name ButtonOutlined.propTypes
 * @type { propTypes }
 * @property { Function } onActionClick - oClick function.
 * @property { String } textButton - Text button.
 * @property { String } classStyles - Button Style Class.
 */
ButtonOutlined.propTypes = {
  onActionClick: PropTypes.func,
  textButton: PropTypes.string,
  classStyles: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  iconComponent: PropTypes.object,
  htmlType: PropTypes.string,
  type: PropTypes.string
};

/**
 * Default properties.
 */
ButtonOutlined.defaultProps = {};

export default ButtonOutlined;
